import { useEffect, useState, useContext } from "react";
import "./CandidateList.css";
import axios from "axios";
import { AuthContext } from "../../../context/AuthContext";
import InterviewLevel from "../interviewlevel/InterviewLevel";
import SelectedCandidates from "../selectedcandidates/SelectedCandidates";
import candidateImg from "../../../assests/candidateImg.png";
import candidateCV from "../../../assests/candidateCV.png";
import { Table, Typography, Image, Space, Divider, Button } from "antd";
import PreviousRound from "../../previousround/PreviousRound";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const { Text } = Typography;

export default function CandidateList({ mrf, onBack }) {
  const [candidates, setCandidates] = useState([]);
  const { authData, backUrl } = useContext(AuthContext);
  const [mrfData, setMrfData] = useState(null);
  const [departments, setDepartments] = useState([]);
  const [organizations, setOrganizations] = useState([]);
  const [showFull, setShowFull] = useState(false);
  const [singleData, setSingleData] = useState(null);
  const [data, setData] = useState(null);
  const [showSelected, setShowSelected] = useState(false);

  const [showInterview, setShowInterview] = useState(false)

  const columns = [
    // {
    //   title: <Text style={{ color: "#ffffff" }}>Candidate ID</Text>,
    //   dataIndex: "id",
    //   key: "id",
    //   render: (id, record) => (
    //     <a
    //       style={{ cursor: "pointer", color: "#0e497b" }}
    //       onClick={() => handleGetOne(record.id)}
    //     >
    //       {id}
    //     </a>
    //   ),
    // },
    {
      title: <Text style={{ color: "#ffffff" }}>Candidate Name</Text>,
      dataIndex: "candidate_name",
      key: "candidate_name",
      render: (c_name, record) => (
        <a
          style={{ cursor: "pointer", color: "#0e497b" }}
          onClick={() => handleGetOne(record.id)}
        >
          {c_name}
        </a>
      ),
    },
    {
      title: <Text style={{ color: "#ffffff" }}>Organization</Text>,
      dataIndex: "organization",
      key: "organization",
      render: () => (mrfData ? getOrganizationName(mrfData.organisation) : "Loading..."),
    },
    {
      title: <Text style={{ color: "#ffffff" }}>Department</Text>,
      dataIndex: "department",
      key: "department",
      render: () => (mrfData ? getDepartmentName(mrfData.department) : "Loading..."),
    },
    {
      title: <Text style={{ color: "#ffffff" }}>Position</Text>,
      dataIndex: "position_display_name",
      key: "position_display_name",
    },
    {
      title: <Text style={{ color: "#ffffff" }}>Mobile No</Text>,
      dataIndex: "mobile_number",
      key: "mobile_number",
    },
    {
      title: <Text style={{ color: "#ffffff" }}>Mail</Text>,
      dataIndex: "email_id",
      key: "email_id",
    },
    {
      title: <Text style={{ color: "#ffffff" }}>Aadhaar</Text>,
      dataIndex: "aadhaar",
      key: "aadhaar",
    },
    {
      title: <Text style={{ color: "#ffffff" }}>Status</Text>,
      dataIndex: "hr_final_status",
      key: "hr_final_status",
    }
  ];

  // Filter out empty candidate names
  const dataSource = candidates.filter((candidate) => candidate.candidate_name !== "");

  useEffect(() => {
    if (mrf) {
      fetchData();
      fetchDataMRF();
      fetchOrganizations();
      fetchDepartments();
    }
  }, [mrf]);

  const fetchData = async () => {
    try {
      // const d = "OnGoing";
      const res = await axios.get(
        `${backUrl}/api/emp/candidates/by-mrf/?mrf_number=${mrf}`,
        { headers: { Authorization: `Bearer ${authData?.access}` } }
      );
      setCandidates(res.data.results);
    } catch (err) {
      console.error("Error fetching candidates:", err);
    }
  };

  const fetchDataMRF = async () => {
    try {
      const res = await axios.get(
        `${backUrl}/api/emp/manpowerrequisitions/${mrf}/`,
        { headers: { Authorization: `Bearer ${authData?.access}` } }
      );
      setMrfData(res.data);
    } catch (err) {
      console.error("Error fetching MRF:", err);
    }
  };

  const fetchOrganizations = async () => {
    try {
      const res = await axios.get(`${backUrl}/api/emp/organisations/`);
      setOrganizations(res.data.results);
    } catch (err) {
      console.error("Failed to fetch organizations:", err);
    }
  };

  const fetchDepartments = async () => {
    try {
      const res = await axios.get(`${backUrl}/api/emp/departments/`);
      setDepartments(res.data.results);
    } catch (err) {
      console.error("Failed to fetch departments:", err);
    }
  };

  const getOrganizationName = (id) => organizations.find(o => o.id === id)?.name || "N/A";
  const getDepartmentName = (id) => departments.find(dep => dep.id === id)?.name || id || "-";

  const handleGetOne = async (cid) => {
    try {
      const res = await axios.get(
        `${backUrl}/api/emp/candidates/all_interview_levels/?candidate_id=${cid}`,
        { headers: { Authorization: `Bearer ${authData?.access}` } }
      );
      console.log(res.data);
      setSingleData(res.data);
      setShowFull(true);
      setData(cid);
      // fetchLevels(cid);
    } catch (err) {
      console.error("Error fetching candidate details:", err);
    }
  };

  const handleSelectCandidates = () => {
    setShowSelected(!showSelected)
  }




  return (
    <>
      <div className="d-flex justify-content-between">
        <div id="bread-container">
          <a className="bread-anchor" id="bread-acr" onClick={onBack}>Back to MRF</a>

          {showFull && (
            <>
              <span className="no-anchor"> / </span>
              <a className="bread-anchor" id="bread-acr" onClick={() => setShowFull(false)}>List</a>
            </>
          )}

          {!showFull && !showSelected ? (
            <>
              <span className="no-anchor"> / </span>
              <a className="bread-anchor" id="bread-acr" onClick={handleSelectCandidates}>Selected Candidates</a>
            </>
            // <div className="mt-0">
            //   <button className="" onClick={handleSelectCandidates}>Selected Candidates</button>
            // </div>
          ) : (
            <>

            </>
          )}

        </div>

      </div>

      {
        !showSelected && (
          <>
            {!showFull ? (
              <div className="table-responsive mt-3">
                <Table
                  columns={columns}
                  dataSource={dataSource.length > 0 ? dataSource : []}
                  rowKey={(record) => record.id}
                  bordered
                  pagination={false}
                  scroll={{ x: "max-content" }}
                  locale={{
                    emptyText: <Text type="secondary">No candidates found.</Text>,
                  }}
                  style={{
                    marginTop: 16,
                    border: "1px solid #d9d9d9",
                  }}
                  components={{
                    header: {
                      cell: (props) => <th {...props} style={{ backgroundColor: "#0e497b", color: "#fff" }} />,
                    },
                  }}
                />
              </div>
            ) : (
              <>
                <div className="candidate-details-wrapper">
                  <div className="card m-3 p-3">
                    <h5>Candidate Profile</h5>
                    <h6>Candidate for {singleData.designation} role</h6>


                    <div className="d-flex justify-content-around mt-5">

                      <Space size="large" direction="horizontal" style={{ justifyContent: "center", display: "flex", marginTop: 32 }}>
                        {/* Candidate Image */}
                        <div style={{ textAlign: "center", cursor: "pointer" }}
                          onClick={async () => {
                            try {
                              const res = await fetch(`${backUrl}/${singleData.candidate_photo}`);
                              const blob = await res.blob();
                              const fileURL = window.URL.createObjectURL(blob);
                              window.open(fileURL, "_blank");
                            } catch (error) {
                              console.error("Error fetching photo:", error);
                            }
                          }}
                        >
                          <Image
                            src={`${backUrl}/${singleData.candidate_photo}`}
                            alt="Candidate"
                            width={150}
                            height={150}
                            style={{ borderRadius: "50%", objectFit: "cover" }}
                            preview={false}
                          />
                        </div>

                        {/* Candidate Resume */}
                        <div style={{ textAlign: "center", cursor: "pointer" }}
                          onClick={async () => {
                            try {
                              const res = await fetch(`${backUrl}/${singleData.candidate_cv}`);
                              const blob = await res.blob();
                              const fileURL = window.URL.createObjectURL(blob);
                              window.open(fileURL, "_blank");
                            } catch (error) {
                              console.error("Error fetching resume:", error);
                            }
                          }}
                        >
                          <Image
                            src={candidateCV}
                            alt="Resume"
                            width={30}
                            height={30}
                            preview={false}
                          />
                          <Text style={{ display: "block", marginTop: 8 }}>Resume</Text>
                        </div>
                      </Space>

                    </div>
                    <Divider />
                    <div className="d-flex justify-content-between gap-4 flex-wrap">
                      <div className="flex-fill" style={{ minWidth: "300px" }}>
                        {[
                          "Candidate Name", "Mobile number",
                          "Email Id", "Aadhaar", "Pan", "Address",
                          "City", "State", "Pincode"
                        ].map((label, idx) => (
                          <div key={idx} className="mb-2">
                            <label>{label}</label>
                            {label === "Address" ? (
                              <textarea className="form-control" value={singleData[label.toLowerCase().replace(/ /g, '_')]} readOnly />
                            ) : (
                              <input type="text" className="form-control" value={singleData[label.toLowerCase().replace(/ /g, '_')]} readOnly />
                            )}
                          </div>
                        ))}
                      </div>
                      <div className="flex-fill" style={{ minWidth: "300px" }}>
                        {[
                          "Education Background", "Technical Background", "Relevant Experience",
                          "Total Experience", "Specification", "Present Salary",
                          "Expected Salary", "Notice Period"
                        ].map((label, idx) => {

                          // Convert present_salary & expected_salary to integer safely
                          const key = label.toLowerCase().replace(/ /g, '_');
                          const value =
                            (label === "Present Salary" || label === "Expected Salary")
                              ? parseInt(singleData[key]) || 0
                              : singleData[key];

                          return (
                            <div key={idx} className="mb-2">
                              <label>{label}</label>

                              {label.includes("Background") ? (
                                <textarea className="form-control" value={value} readOnly />
                              ) : (
                                <input className="form-control" value={value} readOnly />
                              )}
                            </div>
                          );
                        })}
                      </div>


                    </div>



                    <div className="interview-panel bg-light shadow rounded-4 p-4 mt-4 border">
                      <Button style={{ backgroundColor: '#0e497b', color: 'white' }} onClick={() => setShowInterview(!showInterview)}>Interview Level</Button>

                      {/* <Button style={{ backgroundColor: '#0e497b', color: 'white', marginLeft:'10px' }} onClick={() => setShowInterview(!showInterview)}>View Results</Button> */}

                      <br /><br />
                      {
                        showInterview && (
                          <>
                            <InterviewLevel cid={data} />
                          </>
                        )
                      }
                    </div>
                  </div>
                </div>
              </>

            )}
          </>
        )
      }

      {
        showSelected && (
          <>
            <SelectedCandidates mrf_id={mrfData.id} />
          </>
        )
      }


    </>
  );
}
